
export class FilteredOptionsRequest {
    configFile: string;
    whereValue: string;
    limit: number;

    constructor( configFile: string, whereValue: string, limit: number ) {
        this.configFile = configFile;
        this.whereValue = whereValue;
        this.limit = limit;
    }
}
